import EnglishCmsEditor from '@/pages/admin/content/components/EnglishCmsEditor';

export default function AdminEnglishCmsPage() {
  return <EnglishCmsEditor />;
}